module.exports = __webpack_public_path__ + "media/images/icons/monitor-ca33efc2a2c30fa1b04335366c276db0.svg";